module.exports = __webpack_public_path__ + "static/media/agiradom.43f276f7.png";